import React from "react"
import { Col, Glyphicon, ListGroupItem, FormGroup, ControlLabel, FormControl, Button } from "react-bootstrap"

const OrderDetailForm = ({ detailId, getValue, handleChange, handleDelete }) => (
  <ListGroupItem>
    <FormGroup>
      <Col componentClass={ControlLabel} sm={2}>Nama Barang</Col>
      <Col sm={8}>
        <FormControl
          name="productName" id={detailId}
          placeholder="Nama Barang"
          value={getValue("productName", "details", detailId)}
          onChange={handleChange} />
      </Col>
      <Col sm={2} className="text-right">
        <Button bsStyle="danger"
          id={detailId}
          onClick={handleDelete}>
          <Glyphicon glyph="trash" id={detailId} /> Delete Item
        </Button>
      </Col>
    </FormGroup>
    <FormGroup>
      <Col componentClass={ControlLabel} sm={2}>Qty</Col>
      <Col sm={10}>
        <FormControl type="number" min={0} name="orderQuantity" id={detailId} placeholder="Qty"
          value={getValue("orderQuantity", "details", detailId)}
          onChange={handleChange} />
      </Col>
    </FormGroup>
    <FormGroup>
      <Col componentClass={ControlLabel} sm={2}>Gambar Barang (URL)</Col>
      <Col sm={10}>
        <FormControl name="productPictureUrl" id={detailId} placeholder="Gambar Barang (URL)"
          value={getValue("productPictureUrl", "details", detailId)}
          onChange={handleChange} />
      </Col>
    </FormGroup>
    <FormGroup>
      <Col componentClass={ControlLabel} sm={2}>Harga Modal</Col>
      <Col sm={10}>
        <FormControl type="number" min={0} name="purchasePrice" id={detailId} placeholder="Harga Modal"
          value={getValue("purchasePrice", "details", detailId)}
          onChange={handleChange} />
      </Col>
    </FormGroup>
  </ListGroupItem>
)

export default OrderDetailForm


// WEBPACK FOOTER //
// ./src/components/OrderDetailForm.js